import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Brand } from "@/components/Layout";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { LogIn } from "lucide-react";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handle = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    const res = await login(email, password);
    setLoading(false);
    if (res.ok) navigate(res.user?.role === "super_admin" ? "/admin" : "/dashboard");
    else setError(res.error);
  };

  return (
    <div className="min-h-screen bg-[#0A0908] text-[#F4F0EA] flex flex-col">
      <header className="max-w-7xl mx-auto w-full px-6 py-8">
        <Brand />
      </header>

      <div className="flex-1 flex items-center justify-center px-6">
        <div className="w-full max-w-md">
          <div className="text-[10px] tracking-[0.4em] text-[#C5A059] uppercase mb-4">Espace propriétaire</div>
          <h1 className="font-serif text-4xl sm:text-5xl font-light mb-12">Connexion.</h1>

          <form onSubmit={handle} className="space-y-6" data-testid="login-form">
            <div>
              <Label htmlFor="email" className="text-xs uppercase tracking-[0.2em] text-[#A39E93]">Email</Label>
              <Input
                id="email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="mt-2 bg-[#141311] border-[#2C2A26] h-12"
                required
                data-testid="login-email"
              />
            </div>
            <div>
              <Label htmlFor="password" className="text-xs uppercase tracking-[0.2em] text-[#A39E93]">Mot de passe</Label>
              <Input
                id="password"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="mt-2 bg-[#141311] border-[#2C2A26] h-12"
                required
                data-testid="login-password"
              />
            </div>
            {error && <div className="text-sm text-[#E08D8D] border border-[#8C3131]/40 bg-[#8C3131]/10 p-3" data-testid="login-error">{error}</div>}
            <button type="submit" disabled={loading} className="btn-primary w-full justify-center disabled:opacity-50" data-testid="login-submit">
              {loading ? "Connexion…" : (<><LogIn className="w-4 h-4" strokeWidth={1.5} /> Se connecter</>)}
            </button>
          </form>

          <Link to="/forgot-password" className="block text-center mt-6 text-xs uppercase tracking-[0.25em] text-[#A39E93] hover:text-[#C5A059]" data-testid="login-forgot-link">
            Mot de passe oublié ?
          </Link>
          <Link to="/" className="block text-center mt-4 text-xs uppercase tracking-[0.25em] text-[#A39E93] hover:text-[#C5A059]" data-testid="login-back-home">
            ← Retour au site
          </Link>
        </div>
      </div>
    </div>
  );
}
